/* eslint-disable */

export interface FaqEntryDetailDto {
  id: number;
  question: string;
  answer: string;
  amountFeedback: number;
  ratedHelpful?: boolean | null;
  favored: boolean;
  publishedDate: Date;
}

export const fixFaqEntryDetailDtoFromJson = (dto?: FaqEntryDetailDto | null): void => {
  if (!dto) {
    return;
  }
  dto.publishedDate = dto.publishedDate && new Date(dto.publishedDate);
};

export const fixFaqEntryDetailDtoToJson = (dto?: FaqEntryDetailDto | null): void => {
  if (!dto) {
    return;
  }
};
